import { render } from "./CoachUpdate.vue?vue&type=template&id=133426ca&scoped=true"
import script from "./CoachUpdate.vue?vue&type=script&lang=js"
export * from "./CoachUpdate.vue?vue&type=script&lang=js"

import "./CoachUpdate.vue?vue&type=style&index=0&id=133426ca&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133426ca"]])

export default __exports__